import { cn } from "@repo/ui/lib/utils";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

export default function ShippingInfoBanner() {
  const t = useTranslations("shipping-info-banner");
  const pathname = usePathname();
  const paths = [["make-an-offer"], ["checkout", "1"], ["checkout", "1b"]];
  const showbanner = paths.some((path) =>
    path.every((p) => pathname.split("/").includes(p)),
  );

  return (
    <div
      className={cn(
        "sticky top-[var(--desktop-header-height)] max-md:top-[var(--mobile-header-height)] w-full z-50",
        {
          hidden: !showbanner,
        },
      )}
    >
      <div
        className={cn(
          "py-[10px] flex justify-center items-center h-full text-primary-black bg-secondary-grayBlue dark:bg-secondary-magenta5",
        )}
      >
        {t("message")}
      </div>
    </div>
  );
}
